import React from "react";
import RNButton from "@components/Button";
import { TouchableOpacity, Dimensions } from "react-native";
import Text from "@components/CustomText";
import ImageIcon from "@assets/svg/UploadImageIcon";
import colors from "@constants/color";

const AddPhotoButton = ({ label, onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        height: (Dimensions.get("screen").width - 65) / 2,
        width: (Dimensions.get("screen").width - 65) / 2,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: "rgba(0, 0, 0, 0.2)",
        backgroundColor: "white",
        alignItems: "center",
        justifyContent: "center",
        borderStyle: "dashed",
        marginBottom: 10,
      }}
    >
      <ImageIcon />
      <Text
        variant="body_text_4"
        style={{ marginLeft: 7, color: colors.primary, marginTop: 6 }}
      >
        {label}
      </Text>
    </TouchableOpacity>
  );
};

export default AddPhotoButton;
